import React from 'react';
import PropTypes from 'prop-types';
import styles from './ButtonIcon.module.scss';

const ButtonIcon = ({
  icon,
  disabled,
  onClick,
  className,
  link,
}) => {
  const wrapperClasses = [
    styles.button,
    disabled && styles.disabled,
    className,
  ].join(' ');

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      <button
        type="button"
        className={wrapperClasses}
        disabled={disabled}
        onClick={onClick}
      >
        {icon}
      </button>
    </a>
  );
};


ButtonIcon.propTypes = {
  icon: PropTypes.element,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

ButtonIcon.defaultProps = {
  icon: null,
  disabled: false,
  onClick: null,
};

export default ButtonIcon;